import { Box, Button, IconButton, Stack, useMediaQuery } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import { NAVIGATION } from "../../../../locales/components/namespaces";
import MenuDrawer from "../drawer/menuDrawer";
import AccountPopup from "./headerContent/accountPopup/accountPopup";
import HeaderCart from "./headerContent/headerCart/headerCart";

import {
  AccountEnabledIcon,
  AccountIcon,
  LanguageIcon,
  LogoImage,
  MenuIcon,
} from "../../../../assets/header/headerIcon";

import {useHistory, useLocation} from "react-router-dom";
import { getRouteUrl } from "../../../../helpers/routing/getRouteUrl";
import { ROUTE_ABOUT_US } from "../../../../routers/routes";
import BrandMenu from "../drawer/drawerContent/brandMenu/brandMenu";
import CategoryMenu from "../drawer/drawerContent/categoryMenu/categoryMenu";
import HeaderSearch from "./headerContent/headerSearch/headerSearch";
import LanguageMenu from "./headerContent/languageMenu";
import useUserData from "../../../../hooks/user/useUserData";
import BrewLoginModal from "../../../general/login/brewLoginModal";
import ForgotPasswordModal from "../../../general/forgotPass/forgotPasswordModal";
import SignUpForm from "../../../general/signUp/signUpForm";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../../../helpers/errorHandling";
import axios from "axios";
import {API} from "../../../../helpers/constants";

const Header = ({ onCartClick }) => {
    const location = useLocation();
  const theme = useTheme();
  const history = useHistory();
  const [categoryMenuOpen, setCategoryMenuOpen] = useState(false);
  const [brandMenuOpen, setBrandMenuOpen] = useState(false);
  const [languageAnchorEl, setLanguageAnchorEl] = useState(null);
  const [currentLanguage, setCurrentLanguage] = useState("EN");
  const isMobile = useMediaQuery("(max-width:700px)");
  const { t } = useTranslation(NAVIGATION);
  const [accountAnchorEl, setAccountAnchorEl] = useState(null);
  const { isLoggedIn } = useUserData();
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const [isForgotOpen,setIsForgotOpen] = useState(false)
    const [isNew,setIsNew] = useState(false)
    const [menuData, setMenuData] = useState({
        products: [],
        brands: [],
    });
    const [menuLoading, setMenuLoading] = useState(false);

    useEffect(() => {
        let mounted = true;

        const fetchMenu = async () => {
            try {
                setMenuLoading(true);

                const res = await axios({
                    method: "get",
                    url: `${API}/en/brew/menu`,
                });

                if (!mounted) return;

                setMenuData({
                    products: res?.data?.data?.products || [],
                    brands: res?.data?.data?.brands || [],
                });
            } catch (error) {
                handleAxiosErrors(error);
            } finally {
                if (mounted) {
                    setMenuLoading(false);
                }
            }
        };

        fetchMenu();

        return () => {
            mounted = false;
        };
    }, []);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const cond = params.get("cond");

        if (cond === "1") {
            setIsLoginOpen(true)
            enqueueSnackbar(t('Account has been activated.Now you can log in'), {
                variant: 'success',
                autoHideDuration: 3000,
            })
            params.delete("cond");
            history.replace({
                pathname: location.pathname,
                search: params.toString() ? `?${params.toString()}` : "",
            });
        }else if (cond === "2"){
            enqueueSnackbar(t('Activation link is not valid'), {
                variant: 'error',
                autoHideDuration: 3000,
            })
            params.delete("cond");
            history.replace({
                pathname: location.pathname,
                search: params.toString() ? `?${params.toString()}` : "",
            });
        }
    }, [location.search, history, location.pathname]);

    const handleRecoverPass = ()=>{
        setIsLoginOpen(false)
        setIsForgotOpen(true)
    }

    const handleRecoverPassClose = ()=>{
        setIsForgotOpen(false)
    }
    const handleSignUp = ()=>{
        setIsNew(true)
        setIsForgotOpen(false)
        setIsLoginOpen(false)
    }
    const handleSignUpClose = () =>{
        setIsNew(false)
    }
    const handleOpenLogin = () => setIsLoginOpen(true);
    const handleCloseLogin = () => setIsLoginOpen(false);


    const navigationItems = [
    { label: t("nav_products"), id: "products" },
    { label: t("nav_brands"), id: "brands" },
    { label: t("nav_about"), id: "about" },
  ];

  const handleAccountMenuClose = () => {
    setAccountAnchorEl(null);
  };

  const desktopIconButtons = [
    {
      icon: LanguageIcon,
      ariaLabel: "language",
      onClick: (e) => setLanguageAnchorEl(e.currentTarget),
    },
    {
      icon: isLoggedIn ? AccountEnabledIcon : AccountIcon,
      ariaLabel: "account",
      onClick: (e) => setAccountAnchorEl(e.currentTarget),
    },
  ];

  const handleNavClick = (id) => {
    if (id === "products") {
      setCategoryMenuOpen(true);
    } else if (id === "brands") {
      setBrandMenuOpen(true);
    } else if (id === "about") {
      history.push(getRouteUrl(ROUTE_ABOUT_US));
    }
  };

  const handleCategoryMenuClose = () => {
    setCategoryMenuOpen(false);
  };

  const handleBrandMenuClose = () => {
    setBrandMenuOpen(false);
  };

  const handleLanguageMenuClose = () => {
    setLanguageAnchorEl(null);
  };

  const handleLanguageChange = (language) => {
    setCurrentLanguage(language);
  };

  // Handler για το λογότυπο
  const handleLogoClick = () => {
    history.push("/");
  };


  return (
    <>
      <Box
        sx={(theme) => ({
          backgroundColor:"#E9E9E9",
          backdropFilter: "blur(32px)",
          WebkitBackdropFilter: "blur(32px)",
          position: "fixed",
          justifyContent: "space-between",
          alignSelf: "stretch",
          display: "flex",
          padding: 0,
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1201,
          py: { xs: "0.5rem", md: "0.9375rem" },
          px: { xs: "0.625rem", md: "3.125rem" },
          gap: "0.0625rem",
        })}
      >
        {isMobile ? (
          /* =================== MOBILE =================== */
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              width: "100%",
              gap: "1rem",
            }}
          >
            <Box
              component="img"
              src={LogoImage}
              alt="Logo"
              onClick={handleLogoClick}
              sx={{
                width: 118,
                height: 32,
                display: "block",
                flexShrink: 0,
                marginRight: "1rem",
                cursor: "pointer",
                transition: "opacity 0.3s ease",
                "&:hover": {
                  opacity: 0.8,
                },
              }}
            />
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={(t) => ({
                height: 38,
                bgcolor: t.palette.background.paper,
                borderRadius: "19px",
                px: "20px",
                gap: "12px",
                boxSizing: "border-box",
                border: `1px solid ${alpha(t.palette.divider, 0.8)}`,
              })}
            >
              {[
                {
                  icon: MenuIcon,
                  aria: "menu",
                  onClick: () => setCategoryMenuOpen(true),
                },
                {
                  icon: LanguageIcon,
                  aria: "language",
                  onClick: (e) => setLanguageAnchorEl(e.currentTarget),
                },
                {
                  icon: isLoggedIn ? AccountEnabledIcon : AccountIcon,
                  aria: "account",
                  onClick: (e) => setAccountAnchorEl(e.currentTarget),
                },
              ].map(({ icon: Icon, aria, onClick }, i) => (
                <IconButton
                  key={aria}
                  aria-label={aria}
                  onClick={onClick}
                  disableRipple
                  sx={(t) => ({
                    width: 28,
                    height: 28,
                    p: 0,
                    borderRadius: "8px",
                    lineHeight: 0,
                    bgcolor: "transparent",
                    color: t.palette.text.primary,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      bgcolor: t.palette.action.hover,
                      borderRadius: "50%",
                    },
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                  })}
                >
                  <Icon sx={{ width: 18, height: 18 }} />
                </IconButton>
              ))}
                {isLoggedIn && <HeaderCart onClick={onCartClick}/>}
            </Stack>
          </Stack>
        ) : (
          /* ============ DESKTOP (>=700px) ============ */
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            spacing="8"
            sx={{ width: "100%", gap: "2rem" }}
            height="3.125rem"
          >
            <Box
              component="img"
              src={LogoImage}
              alt="Logo"
              onClick={handleLogoClick}
              sx={{
                width: "11.21625rem",
                height: "3.01513rem",
                display: "block",
                color: theme.palette.primary.main,
                cursor: "pointer",
                transition: "opacity 0.3s ease",
                "&:hover": {
                  opacity: 0.8,
                },
              }}
            />

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flex: 1,
                minWidth: 0,
                height: 50,
                backgroundColor: "#fff",
                borderRadius: "50px",
                pl: { md: 3 },
                pr: { md: 2 },
                py: 0.5,
              }}
            >
              <Stack direction="row" spacing={2.5} alignItems="center">
                {navigationItems.map((item, index) => (
                  <Button
                    key={index}
                    onClick={() => handleNavClick(item.id)}
                    disableRipple
                    sx={(theme) => ({
                      color: "#000",
                      fontWeight: 900,
                      fontSize: 16,
                      lineHeight: "120%",
                      fontFamily: "'Zen Maru Gothic', Arial, sans-serif",
                      minWidth: "auto",
                      p: 0,
                      transition: "color .3s ease",
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: theme.palette.primary.main,
                      },
                      "&:focus-visible": {
                        outline: "none",
                        color: theme.palette.primary.main,
                      },
                      "&:active": {
                        color: theme.palette.primary.dark,
                      },
                    })}
                  >
                    {item.label}
                  </Button>
                ))}
              </Stack>
              <Stack direction="row" spacing="15px" alignItems="center">
                {/*  HeaderSearch component */}
                <HeaderSearch />

                {desktopIconButtons.map((item, index) => (
                  <IconButton
                    key={index}
                    aria-label={item.ariaLabel}
                    onClick={item.onClick}
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "#ffffff",
                      borderRadius: "20px",
                      p: "10px",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    <item.icon
                      sx={{
                        width: 20,
                        height: 20,
                        transition: "all 0.3s ease",
                      }}
                    />
                  </IconButton>
                ))}
                  {isLoggedIn && <HeaderCart onClick={onCartClick}/>}
              </Stack>
            </Stack>
          </Stack>
        )}
      </Box>

      {/* Category Menu Drawer */}
      <MenuDrawer open={categoryMenuOpen} onClose={handleCategoryMenuClose}>
        <CategoryMenu
            onClose={handleCategoryMenuClose}
            menuData={menuData.products}
            loading={menuLoading}
        />
      </MenuDrawer>

      {/* Brand Menu Drawer */}
      <MenuDrawer open={brandMenuOpen} onClose={handleBrandMenuClose}>
        <BrandMenu
            onClose={handleBrandMenuClose}
            menuData={menuData.brands}
            loading={menuLoading}
        />
      </MenuDrawer>

      {/* Language Menu Popper */}
      <LanguageMenu
        open={Boolean(languageAnchorEl)}
        anchorEl={languageAnchorEl}
        onClose={handleLanguageMenuClose}
        currentLanguage={currentLanguage}
        onLanguageChange={handleLanguageChange}
      />

      {/* Account Popup */}
      <AccountPopup
        open={Boolean(accountAnchorEl)}
        anchorEl={accountAnchorEl}
        onClose={handleAccountMenuClose}
        isLoggedIn={isLoggedIn}
        onLoginClick={() => {
            handleAccountMenuClose();
            handleOpenLogin();
        }}
        onSignUp={()=> {
            handleAccountMenuClose()
            setIsNew(true)
        }}
      />
        <BrewLoginModal
            open={isLoginOpen}
            onClose={handleCloseLogin}
            onForgotPassword={handleRecoverPass}
            onSignUp={handleSignUp}
        />
        <ForgotPasswordModal
            open={isForgotOpen}
            onClose={handleRecoverPassClose}
        />
        <SignUpForm
            open={isNew}
            onClose={handleSignUpClose}
            onLogin={handleOpenLogin}
        />

    </>
  );
};

export default Header;
